/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useRef, type MutableRefObject, type ReactNode } from 'react';

interface HasFetchedContextValue {
  hasFetchedRef: MutableRefObject<boolean>;
}

const HasFetchedContext = createContext<HasFetchedContextValue | null>(null);

interface HasFetchedProviderProps {
  children: ReactNode;
}

export const HasFetchedProvider: React.FC<HasFetchedProviderProps> = ({ children }) => {
  const hasFetchedRef = useRef<boolean>(false);

  return <HasFetchedContext.Provider value={{ hasFetchedRef }}>{children}</HasFetchedContext.Provider>;
};

export function useHasFetchedRef(): MutableRefObject<boolean> {
  const ctx = useContext(HasFetchedContext);
  if (!ctx) {
    throw new Error('useHasFetchedRef must be used within a <HasFetchedProvider>');
  }
  return ctx.hasFetchedRef;
}
